<template>
  <div class="index">

    <el-container>
      <!--主要显示区域-->
      <el-main style="padding: 20px 0" width="600px">
        <!--轮播图-->
        <div class="block" style="margin: 10px">
          <el-carousel :interval="6000" trigger="click" height="400px" ref="carousel"
                       @click.native="clickLooper()">
            <el-carousel-item v-for="item in imgList" :key="item.title">
              <el-image :src="item.imageUrl" :alt="item.title"></el-image>
            </el-carousel-item>
          </el-carousel>
        </div>

        <!--最新文章-->
        <div style="margin: 10px" v-for="(collectionItem,collectionIndex) in articleCollectionContentList" :key="collectionIndex">
          <div v-show="collectionItem.type === 'MAIN'">
            <h1>{{ collectionItem.name }}</h1>
            <div class="article-list-container">
              <el-card class="article-list-item-container" style="margin: 10px auto" v-for="(item,index) in collectionItem.contentArticleList"
                       :key="index">
                <!--<router-link :to="'/articleDetail/' + item.id"><a @click="getArticleId(item.id)">{{item.title}}</a></router-link>-->
                <div><h3>{{ item.title }}</h3></div>
                <div><h6>{{ item.summary }}</h6></div>
                <!--<router-link :to="'/articleDetail/' + item.id">-->
                <router-link :to="'/article/articleDetail/' + item.id" target="_blank">
                  <!--<a class="article-list-item-a">{{item.title}}</a>-->
                  <a @click="addViewCount(item.id)">查看详情</a>
                  <!--<a>查看详情</a>-->
                </router-link>
                <div style="font-size: small;float: right">浏览量：{{ item.viewCount }}</div>
              </el-card>
            </div>
          </div>
        </div>
      </el-main>

      <!--右边-->
      <el-aside width="350px" style="padding: 20px 0">
        <!--后端：springboot内容-->
        <div style="margin: 10px" v-for="(collectionItem,collectionIndex) in articleCollectionContentList" :key="collectionIndex">
          <el-card class="box-card" v-show="collectionItem.type === 'ASIDE'">
            <div slot="header" class="clearfix">
              <span>{{ collectionItem.name }}</span>
            </div>
            <div v-for="(item,index) in collectionItem.contentArticleList" :key="index" class="aside-list">
              <ul class="aside-list_ul">
                <router-link :to="'/article/articleDetail/' + item.id" target="_blank">
                  <li class="aside-list_ul_li">
                    <a>{{ index + 1 }}: {{ item.title }}</a>
                  </li>
                </router-link>
              </ul>
            </div>
          </el-card>
        </div>
      </el-aside>
    </el-container>

    <!--&lt;!&ndash;音乐播放器&ndash;&gt;-->
    <!--<APlayer :audio="musicList" :lrcType="0" :volume="0.2" :autoplay="false" fixed></APlayer>-->

  </div>
</template>

<script>
import {getIndexLooper, getRecommendList, getAsideList} from "@/api/get";
import {addViewCount} from "@/api/post";
import {getArticleCollectionContentList} from "@/api/article";
// import {getMusicList} from "@/api/get";

export default {
  name: "Index",
  data() {
    return {
      token: "",
      imgList: [],
      recommendList: [],
      date: new Date(),

      houduanList: [],
      qianduanList: [],
      yunweiList: [],
      // musicList:[],

      articleCollectionContentList:[],
    }
  },
  created() {
    // this.token = this.$store.state.user.token;
    // console.log("token"+JSON.stringify(this.$store.state))
    this.getLooper();
    this.getRecommendList();
    // this.getAsideList();
    this.getArticleCollectionContentList();
    // //获取音乐
    // this.getMusic();
  },
  methods: {
    getLooper() {
      getIndexLooper().then(response => {
        if (response.code === 200) {
          this.imgList = response.rows
        }
      })
    },
    getRecommendList() {
      getRecommendList().then(response => {
        if (response.code === 200) {
          this.recommendList = response.rows
        }
      })
    },
    getAsideList() {
      getAsideList().then(response => {
        if (response.code === 200) {
          this.houduanList = response.data.houduanList;
          this.qianduanList = response.data.qianduanList;
          this.yunweiList = response.data.yunweiList;
        }
      })
    },
    getArticleCollectionContentList() {
      getArticleCollectionContentList().then(response => {
        if (response.code === 200) {
          this.articleCollectionContentList = response.data;
        }
      })
    },
    addViewCount(articleId) {
      //文章流量数+1
      addViewCount(articleId).then();
    },
    clickLooper() {
      let activeIndex = this.$refs.carousel.activeIndex
      // this.$message({
      //     showClose: true,
      //     message: this.imgList[activeIndex].title,
      //     type: 'success'
      // });

      if (this.imgList[activeIndex].targetUrl != null && this.imgList[activeIndex].targetUrl !== "") {
        window.location.href = "http://" + this.imgList[activeIndex].targetUrl;
      } else if (this.imgList[activeIndex].articleId != null && this.imgList[activeIndex].articleId !== "") {
        this.$router.push('/article/articleDetail/' + this.imgList[activeIndex].articleId);
      } else {
        // this.$message({
        //     showClose: true,
        //     message: "该轮播图暂时没有跳转",
        //     type: 'success'
        // });
        console.log("该轮播图暂时没有跳转")
      }
    },
    // //获取音乐
    // getMusic(){
    //     getMusicList().then(response => {
    //         if (response.code===200){
    //             this.musicList = response.rows
    //         }
    //     })
    // },
  }
}
</script>

<style scoped>
.index {
  width: 60%;
  margin: -20px auto 0;
  /*background: #F0F2F5;*/
}

/*轮播图*/
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 400px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}

.me-login-design-color {
  color: #5FB878 !important;
}

/*右侧栏*/
.aside-list_ul {
  list-style: none;
  margin: 0px;
  padding: 0px;
}

.aside-list_ul_li {
  /*margin: 12px;*/
  /*margin-left: 10px;*/
}

.aside-list_ul_li a {
  font-size: 16px;
  color: #000;
  display: inline-block;
  text-align: left;
  list-style: none;
  margin: 10px;
}

.aside-list_ul_li:hover {
  background: #E4E6E9;
  border-radius: 9px;
}

.aside-list_ul-active li {
  background: #E4E6E9;
  color: white;
}
</style>
